import Navbar from './Navbar';

export default function Gallery() {
    return(
        <>


        <center><h1>Gallery</h1></center>

        <Navbar />
        
        
        
        </>
    )
}